import React from 'react'
import { NavLink } from 'react-router-dom';
import AppearOnScroll from './AppearOnScroll';

function ListItem({ project }) {
  return (
    <NavLink to={`/projects/${project.project_name}`}>
      <AppearOnScroll>
      <div className="flex flex-col gap-4">
        <div className="flex w-full items-center aspect-[4/3] overflow-hidden rounded-image">
          <img
            src={`/img/${project.folder}/${project.main_image}`}
            alt="project"
            className="w-full h-full object-cover rounded-image hover:scale-105 transition-all"
          />
        </div>

        <div className="flex flex-col items-start text-left gap-1 md:gap-2 cursor-pointer">
          <AppearOnScroll>
          <h3 className="font-display font-medium lg:text-xl text-lg text-dark-900">
            {project.project_name}
          </h3>
          </AppearOnScroll>
          <AppearOnScroll delay={0.3}>
          <h4 className="font-body font-normal lg:text-lg text-base text-dark-700">
            {project.keywords}
          </h4>
          </AppearOnScroll>
        </div>
      </div>
      </AppearOnScroll>
    </NavLink>
  );
}

  export default ListItem;